// import  "./NewLesson.css";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import LessonForm from "./components/LessonForm";
import { useNavigate ,useParams} from "react-router-dom";

import lessonStore from "../lessonStore";
import { useEffect, useState } from "react";
import appStore from "../../../base/stores/AppStore";
import { LessonDI, LessonFormObjectDI } from "../types";
import _ from "lodash";
import { getLesson, getLessonUrl } from "../services/getLesson";
import { editLesson } from "../services/editLesson";
import CustomModal from "../../../base/modal/Modal";
import SubHeader from "../../../base/sub-header/SubHeader";
import { useTitle } from "react-use";
import AppStore from "../../../base/stores/AppStore";
import NotFound from "../../../base/not-found/NotFound";

const EditLesson = () => {

  useEffect(() => {
    lessonStore.getLists();
  }, []);
  const { lessonUrl } = useParams<{ lessonUrl: string }>();
  
   const navigate = useNavigate(); 
  const [hasError, setHasError] = useState(false);
  const { lists } = lessonStore;
  const { t } = useTranslation();
  useTitle(t("General-content-header") + t("Lesson-edit-lesson-header"));
  const [lesson, setLesson] = useState<LessonDI>();
  const [errorMessage, setErrorMessage] = useState("");
  const [errorCode, setErrorCode] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [isExistLesson, setIsExistLesson] = useState<boolean>(true);

  useEffect(() => {
    fetchLesson();
  }, [lessonUrl]);

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/NewLesson.css";
    document.head.appendChild(link);
  
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const fetchLesson = async () => {
    if (!lessonUrl) {
      setErrorMessage(t("Error-InvalidLessonUrl"));
      setModalOpen(true);
      return;
    }
  
    try {
      appStore.incrementLoadingProcedure();
      const existLesson = await getLessonUrl(lessonUrl);
      if (!existLesson) return setIsExistLesson(false);
      setIsExistLesson(true);
      setLesson(existLesson);
    } catch (error: any) {
      if (error.statusCode < 400) {
        setErrorMessage(error.errorMessages);
      } else {
        setErrorMessage(t("GeneralError"));
      }
      setErrorCode(error.statusCode);
      setModalOpen(true);
    } finally {
      appStore.decrementLoadingProcedure();
    }
  };

  const handleModalStatus = (errorMode: boolean) => {
    setModalOpen(errorMode);
  };

  const handleSubmit = async (form: LessonFormObjectDI) => {
    try {
      appStore.incrementLoadingProcedure();
      await editLesson({
        ...form,
        id: lesson?.id,
        projectPartnerIds: form.projectPartnerIds.map(id => +id),
      });
      lessonStore.getLists();
      lessonStore.setLessonJustSaved(true);
      navigate(AppStore.lessonsRoute);
    } catch (error: any) {
      if (error.statusCode === 2) {
        setModalOpen(true);
        setErrorMessage(t("Lesson-main-error-validation"));
        return;
      }
      if (error.statusCode < 400) {
        setErrorMessage(error.errorMessages);
      } else {
        setErrorMessage(t("GeneralError"));
      }
      setErrorCode(error.statusCode);
      setModalOpen(true);
    } finally {
      appStore.decrementLoadingProcedure();
    }
  };

  return (
    <>
      {isExistLesson ? (
        <div className={'container'}>
          <div className=""><SubHeader
            links={[
              { name: "Breadcrumbs-Home-Page", route: "/" },
              { name: "Lesson-search-header", route: AppStore.lessonsRoute },
              { name: "Lesson-edit-lesson-header", isLast: true },
            ]}
            showBackgroundImage={false}
          />
          
          <div tabIndex={1} className={'header'}>
            {t("Lesson-edit-lesson-header")}
          </div>
          {hasError && (
            <div
              className={'error'}
              role="alert"
              aria-label={t("Lesson-main-error-validation")}
            >
              {t("Lesson-main-error-validation")}
            </div>
          )}</div>
          <LessonForm
            onErrorStateChange={setHasError}
            editedLesson={lesson}
            availableValues={{
              allLessonField: lists.fieldId.map((i) => ({
                value: i.id,
                text: i.name,
                hide: i.hide,
              })),
              allLessonTags: lists.lessonTags.map((i) => ({
                value: i.id,
                text: i.name,
                hide: i.hide,
              })),
              allProjectName: lists.projectNameId.map((i) => ({
                value: i.id,
                text: i.name,
                hide: i.hide,
              })),
              allProjectPartners: lists.projectPartnerIds.map((i) => ({
                value: i.id,
                text: i.name,
                hide: i.hide,
              })),
              allStep: lists.stepId.map((i) => ({
                value: i.id,
                text: i.name,
                hide: i.hide,
              })),
              allProjectType: lists.projectTypeId.map((i) => ({
                value: i.id,
                text: i.name,
                hide: i.hide,
              })),
              allExternalFactorInvolved: lists.externalFactorInvolvedId.map(
                (i) => ({ value: i.id, text: i.name, hide: i.hide })
              ),
              allOrganizationalUnit: lists.organizationalUnitId.map((i) => ({
                value: i.id,
                text: i.name,
                hide: i.hide,
              })),
            }}
            onSubmit={(form) => {
              handleSubmit(form);
            }}
          />
          {modalOpen ? (
            <CustomModal
              text={errorMessage}
              isOpen={modalOpen}
              handleModalStatus={handleModalStatus}
            />
          ) : null}
        </div>
      ) : (
        <NotFound />
      )}
    </>
  );
};

export default observer(EditLesson);
